import React from 'react'
import { useCustomerPortal } from '../hooks'

const ManageSubscription = ({ stripeCustomerId }) => {
  const { handleCustomerPortalSubmit } = useCustomerPortal()

  return (
    <section className="sore-thumb">
      <div className="product Box-root">
        <div className="description Box-root">
          <h3>Your Subscription is Up and Running!</h3>
        </div>
      </div>
      <form onSubmit={handleCustomerPortalSubmit}>
        <div style={{ visibility: 'hidden' }}>{stripeCustomerId}</div>
        <button className="manage-subs-btn" type="submit">
          Manage your billing information
        </button>
      </form>
    </section>
  )
}

export default ManageSubscription
